<template>
  <div>
    <header class="header-main">
      <div class="containers" v-show="show">
        <router-link to="/" class="logo-header">
          <img :src="getTranslations.project_logo_img" alt="">
        </router-link>
        <nav class="main-nav main-nav--home">
          <ul class="main-nav__lang " id="get_started_menu" style="cursor:pointer" v-if="!hideLangSelection">
            <li class="dropdown">
              <a><i class="icon-planet"></i><i class="icon-arrow-down"></i></a>
              <ul>
                <li v-for="(value, key) in availableLocales" :key="key">
                  <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
                </li>
              </ul>
            </li>
          </ul>
          <button data-menu="nav_dropdown" class="nav__toggle nav__toggle--home logged_out_menu"><span></span></button>
          <div id="nav_dropdown" class="nav-dropdown">
            <ul class="mobile-menu__list">
              <li class="mobile-menu__item" v-if="!hidePrizePage">
                <router-link to="/prizes" :class="['mobile-menu__link', getActiveTabClass('/prizes')]">
                  {{ getTranslations.visitor_visitor_header_prizes }}
                </router-link>
              </li>
              <li class="mobile-menu__item" v-if="!hideWinners">
                <router-link to="/winners" :class="['mobile-menu__link', getActiveTabClass('/winners')]">
                  {{ getTranslations.visitor_visitor_header_winners }}
                </router-link>
              </li>
              <li class="mobile-menu__item">
                <router-link to="/howItWorks" :class="['mobile-menu__link', getActiveTabClass('/howItWorks')]">
                  {{ getTranslations.visitor_visitor_header_how_it_works }}
                </router-link>
              </li>
              <li class="mobile-menu__item">
                <router-link v-if="!existThisPathInForbiddenPages('/login')" to="/login"
                             class="mobile-menu__link btn btn--outline btn--small btn--icon login-btn-nav">
                  <i class="icon-profile"></i>
                  <span>{{ getTranslations.visitor_visitor_header_login }}</span>
                </router-link>
              </li>
              <li class="mobile-menu__item reg_log">
                <a @click.prevent="encryptUrlBuilder"
                   style="cursor: pointer"
                   class="mobile-menu__link btn btn--white btn--small register-btn-nav">
                  {{ getTranslations.visitor_visitor_header_register }}
                </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <router-view></router-view>
    <footer :class="['footer-main', (duelSkin !== 3)  ? '' : 'with_brand']" v-if="logoOnFooter">
      <div class="containers">
        <nav class="footer-nav">
          <ul class="footer-nav__list">
            <li>
              <div class="footer_align" v-if="duelSkin === 3">
                <span>{{ getTranslations.visitor_visitor_product_by }}</span><img
                :src=getTranslations.project_config_visitor_footer_logo></div>
            </li>
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_t_and_c }}</a></li>
            <li><a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank">{{ getTranslations.visitor_visitor_privacy_policy }}</a></li>
          </ul>
        </nav>
      </div>
    </footer>
    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <operator-selection v-if="getSelectOperatorModalChoice()"
                        @close="toggleSelectOperatorModal(false);">
    </operator-selection>
    <loading v-if="SHOW_LOADING"
             @close="SHOW_LOADING = false">
    </loading>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import Vue from 'vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/flow/SimplifyRegistration';
import operatorSelection from '@/components/home/modals/flow/OperatorSelectionModal';
import loading from '@/components/home/modals/shared/Loading';
import { handleLanguageDropdown, handleBurgerButton, closeTab } from '../../common/jQuery';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'navigation-header',
  mixins: [RegistrationFlowMixin],
  components: { simplifyRegistration, operatorSelection, loading },
  data() {
    return {
      show: true,
      currentTabPath: '',
      showSimpleRegistrationModal: false,
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getIntegration(to);
    });
  },
  created() {
    this.currentTabPath = sessionStorage.getItem('visitorCurrentTabPath');
  },
  mounted() {
    console.log(this.getDisplayedLocale);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurgerButton();
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    this.getIntegration(to);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    sessionStorage.setItem('visitorCurrentTabPath', to.path);
    closeTab();
    next();
  },
  methods: {
    ...mapActions('common', [
      'facebookSDKApi',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapActions('profile', [
      'storeVisitorWinners',
      'storeAvailablePrizeTypes',
    ]),
    ...mapMutations('i18n', [
      'updateLocaleFromLocalStorage',
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    showPage(value) {
      this.show = value;
    },
    encryptUrlBuilder() {
      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationAction();
      }
    },
    getIntegration(to) {
      if (to.path === '/') this.checkForRegisterRedirect(to);
    },
    checkForRegisterRedirect(to) {
      this.getIntegrationParametersCheck()(to);
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
          this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
            this.facebookSDKApi();
            this.changeCSSFile();
          });
        });
      });
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },

  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapState('common', [
      'hideLangSelection',
      'hidePrizePage',
      'hideWinners',
      'logoOnFooter',
      'multiOperatorInfo',
      'duelSkin',
    ]),
    ...mapGetters('common', [
      'existThisPathInForbiddenPages',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Visitor.vue